import { Injectable } from '@angular/core';

import { CoursesService } from 'src/core/index/services.index';
import { ModulePackage } from 'src/core/index';

@Injectable({
    providedIn: 'root'
})
export class CoursesServiceCustom extends CoursesService {

    override convertPackageModule(module: ModulePackage, courseId?: string) {
        const parentReturn = super.convertPackageModule(module, courseId);
        return {
            ...parentReturn,
            description: undefined,
        }
    }

}